export default function Experience() {
  return (
    <section
      id="experience"
      className="relative overflow-hidden"
      style={{ padding: '8rem 4rem' }}
    >
      {/* Subtle background image */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/0d90661f7366e964b8673ef2f8427127/51224f7b89ff320e1c407ce83669f36f.webp"
          alt="窯の背景"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-[#3a1f0d]/75" />
      </div>

      <div className="relative max-w-2xl mx-auto text-center">
        {/* Label */}
        <span className="inline-block bg-white/20 text-white text-xs font-rounded font-bold tracking-widest px-3 py-1.5 rounded-full mb-8">
          / EXPERIENCE
        </span>

        {/* Heading */}
        <h2
          className="text-3xl md:text-4xl lg:text-5xl font-rounded font-black text-white mb-14 leading-tight"
        >
          ピザを食べに、<br />奄美に来ました。
        </h2>

        {/* Body text */}
        <div
          className="text-white/95 font-rounded text-base md:text-lg text-left space-y-6 max-w-xl mx-auto"
          style={{ lineHeight: '2.0' }}
        >
          <p>
            そう言ってくれるお客さんが、ひとりずつ増えています。
          </p>
          <p>
            最初は観光のついでに寄ってくれただけ。<br />
            でも気づいたら、<br />
            「次はふぅばてぇのために来よう」って飛行機を取ってくれている。
          </p>
          <p>
            島の素材を使って、島の空気の中で、<br />
            窯から出たばかりのアツアツを食べる。
          </p>
          <p>
            それはたぶん、「おいしいピザ」だけじゃなくて、
          </p>
          {/* Highlighted phrase */}
          <p>
            <span className="text-[#f4c87a] font-black text-xl md:text-2xl">
              「ここに来ないとできない体験」
            </span>
            <span className="text-white/95">だから。</span>
          </p>
          <p>
            わざわざ来てくれた人に、<br />
            「来てよかった」と思ってもらえるお店でありたい。
          </p>
          <p>
            ふぅばてぇは、そんな気持ちでピザを焼いています。
          </p>
        </div>

        {/* Decorative divider */}
        <div className="mt-14 flex items-center justify-center gap-4">
          <div className="w-16 h-px bg-white/30" />
          <div className="w-2 h-2 rounded-full bg-white/40" />
          <div className="w-16 h-px bg-white/30" />
        </div>
      </div>
    </section>
  );
}
